import { apiErrorSchema } from '@khc/contracts';
import { assertHubWriteAllowed } from './writeGuard';

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly fields?: Record<string, string>,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/** 统一请求封装：同源 Cookie、JSON、契约化错误 */
export async function apiRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  assertHubWriteAllowed(path, init);
  const headers = new Headers(init.headers);
  if (init.body && !headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }

  const res = await fetch(path, {
    ...init,
    headers,
    credentials: 'same-origin',
  });

  const text = await res.text();
  let data: unknown = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = null;
    }
  }

  if (!res.ok) {
    const parsed = apiErrorSchema.safeParse(data);
    if (parsed.success) {
      throw new ApiError(
        res.status,
        parsed.data.error.code,
        parsed.data.error.message,
        parsed.data.error.fields,
      );
    }
    throw new ApiError(res.status, 'http_error', `HTTP ${res.status}`);
  }

  return data as T;
}
